var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({},on),[_vm._v(" "+_vm._s(_vm.version)+" ")])]}}])},[_c('c-compiled-template',{attrs:{"template":_vm.template,"context":_vm.context}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }